import { render, staticRenderFns } from "./aboutCompany.vue?vue&type=template&id=ed21f190&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./aboutCompany.vue?vue&type=script&lang=js"
export * from "./aboutCompany.vue?vue&type=script&lang=js"
import style0 from "./aboutCompany.vue?vue&type=style&index=0&id=ed21f190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed21f190",
  null
  
)

export default component.exports